// 全局变量
let currentLanguage = 'zh';
let routesData = null;
let translations = {};
import mapboxgl from 'mapbox-gl';
let map = null;

// Mapbox访问令牌 (需要替换为实际的令牌)
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoieGlhb2thbmciLCJhIjoiY2lqc2d2NXlyMGhkbHU0bTVtcGNiOWxseCJ9.J5qsX13KKNT1slMGS-MOLg';

// DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', async function() {
    try {
        // 首先加载路线数据，确保后续操作可用
        await loadRoutesData();

        // 初始化应用（包括地图）
        await initializeApp();
        
        // 设置事件监听器
        setupEventListeners();
        
        // 渲染路线卡片
        renderRouteCards();
        
        console.log('应用初始化完成');
    } catch (error) {
        console.error('应用初始化失败:', error);
        showError('应用加载失败，请刷新页面重试');
    }
});

// 初始化应用
async function initializeApp() {
    // 检测用户语言偏好
    detectUserLanguage();
    
    // 加载翻译文件
    await loadTranslations();
    
    // 应用翻译
    applyTranslations();
    
        // 初始化导航栏
    initializeNavbar();
    
    // 初始化地图
    initializeMap();
}

// 检测用户语言偏好
function detectUserLanguage() {
    // 从localStorage获取保存的语言设置
    const savedLanguage = localStorage.getItem('hikechina-language');
    if (savedLanguage && ['zh', 'en', 'ja', 'ko'].includes(savedLanguage)) {
        currentLanguage = savedLanguage;
        return;
    }
    
    // 从浏览器语言检测
    const browserLanguage = navigator.language || navigator.userLanguage;
    if (browserLanguage.startsWith('zh')) {
        currentLanguage = 'zh';
    } else if (browserLanguage.startsWith('en')) {
        currentLanguage = 'en';
    } else if (browserLanguage.startsWith('ja')) {
        currentLanguage = 'ja';
    } else if (browserLanguage.startsWith('ko')) {
        currentLanguage = 'ko';
    } else {
        currentLanguage = 'zh'; // 默认中文
    }
}

// 加载翻译文件
async function loadTranslations() {
    try {
        const response = await fetch(`/locales/${currentLanguage}.json`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        translations = await response.json();
    } catch (error) {
        console.error('加载翻译文件失败:', error);
        // 如果加载失败，尝试加载中文作为后备
        if (currentLanguage !== 'zh') {
            try {
                const fallbackResponse = await fetch('/locales/zh.json');
                translations = await fallbackResponse.json();
                currentLanguage = 'zh';
            } catch (fallbackError) {
                console.error('加载后备翻译文件也失败:', fallbackError);
            }
        }
    }
}

// 应用翻译
function applyTranslations() {
    const elements = document.querySelectorAll('[data-i18n]');
    elements.forEach(element => {
        const key = element.getAttribute('data-i18n');
        const translation = getTranslation(key);
        if (translation) {
            element.textContent = translation;
        }
    });
    
    // 更新语言选择器显示
    updateLanguageSelector();
    
    // 更新HTML lang属性
    document.documentElement.lang = currentLanguage;
}

// 获取翻译文本
function getTranslation(key) {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            return null;
        }
    }
    
    return typeof value === 'string' ? value : null;
}

// 初始化Mapbox地图
function initializeMap() {
    const mapContainer = document.getElementById('map');
    if (!mapContainer) {
        return; // 如果页面上没有地图容器，则不执行任何操作
    }

    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/light-v11', // 使用简洁的浅色主题
        center: [104.1954, 35.8617], // 地图中心点设为中国
        zoom: 3.5, // 缩放级别以展示整个中国
        pitch: 0,
        bearing: 0,
        interactive: false, // 禁用所有地图交互
    });

    map.on('load', () => {
        console.log('Mapbox map has loaded.');
        // 延迟执行以确保地图容器已正确调整大小
        setTimeout(() => {
            map.resize();
            console.log('Map resized.');
            loadAllRoutesOnMap();
        }, 200);
    });
}

// 在地图上为每条路线添加标记（使用Mapbox GL Marker）
function loadAllRoutesOnMap() {
    if (!routesData || routesData.length === 0) {
        console.warn('没有路线数据可用于在地图上显示标记。');
        return;
    }

    routesData.forEach(route => {
        if (route.coordinates && route.coordinates.center) {
            // 创建标记
            const marker = new mapboxgl.Marker()
                .setLngLat(route.coordinates.center)
                .addTo(map);
            
            console.log(`已添加标记: ${route.name.zh} at ${route.coordinates.center}`);
        }
    });
    
    console.log('所有路线标记已添加完成。');
}

// 更新语言选择器
function updateLanguageSelector() {
    const currentLangElement = document.getElementById('current-lang');
    const languageNames = {
        'zh': '中文',
        'en': 'English',
        'ja': '日本語',
        'ko': '한국어'
    };
    
    if (currentLangElement) {
        currentLangElement.textContent = languageNames[currentLanguage] || '中文';
    }
}

// 设置事件监听器
function setupEventListeners() {
    // 语言切换
    setupLanguageSwitcher();
    
    // 移动端菜单
    setupMobileMenu();
    
    // 平滑滚动
    setupSmoothScroll();
    
    // 导航栏滚动效果
    setupNavbarScroll();
    
    // Hero按钮点击
    setupHeroButtons();
}

// 设置语言切换器
function setupLanguageSwitcher() {
    const languageBtn = document.getElementById('language-btn');
    const languageMenu = document.getElementById('language-menu');
    const languageLinks = languageMenu?.querySelectorAll('[data-lang]');
    
    if (languageBtn && languageMenu) {
        // 切换语言菜单显示/隐藏
        languageBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            languageMenu.classList.toggle('hidden');
        });
        
        // 点击其他地方关闭菜单
        document.addEventListener('click', () => {
            languageMenu.classList.add('hidden');
        });
        
        // 语言选择
        languageLinks?.forEach(link => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                const newLanguage = link.getAttribute('data-lang');
                if (newLanguage && newLanguage !== currentLanguage) {
                    await switchLanguage(newLanguage);
                }
                languageMenu.classList.add('hidden');
            });
        });
    }
}

// 切换语言
async function switchLanguage(newLanguage) {
    try {
        currentLanguage = newLanguage;
        localStorage.setItem('hikechina-language', newLanguage);
        
        // 重新加载翻译
        await loadTranslations();
        
        // 应用翻译
        applyTranslations();
        
        // 重新渲染路线卡片
        renderRouteCards();
        
        console.log(`语言已切换到: ${newLanguage}`);
    } catch (error) {
        console.error('切换语言失败:', error);
        showError('语言切换失败，请重试');
    }
}

// 设置移动端菜单
function setupMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobile-menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (mobileMenuBtn && mobileMenu) {
        mobileMenuBtn.addEventListener('click', () => {
            mobileMenu.classList.toggle('hidden');
        });
    }
}

// 设置平滑滚动
function setupSmoothScroll() {
    const navLinks = document.querySelectorAll('a[href^="#"]');
    
    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            if (href.startsWith('#')) {
                e.preventDefault();
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    const offsetTop = targetElement.offsetTop - 80; // 考虑固定导航栏高度
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
}

// 设置导航栏滚动效果
function setupNavbarScroll() {
    const navbar = document.getElementById('navbar');
    let lastScrollY = window.scrollY;
    
    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        
        if (navbar) {
            if (currentScrollY > 100) {
                navbar.classList.add('shadow-lg');
            } else {
                navbar.classList.remove('shadow-lg');
            }
        }
        
        lastScrollY = currentScrollY;
    });
}

// 设置Hero按钮
function setupHeroButtons() {
    const exploreBtn = document.querySelector('[data-i18n="hero.cta1"]');
    const learnMoreBtn = document.querySelector('[data-i18n="hero.cta2"]');
    
    if (exploreBtn) {
        exploreBtn.addEventListener('click', () => {
            const routesSection = document.getElementById('routes');
            if (routesSection) {
                const offsetTop = routesSection.offsetTop - 80;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }
    
    if (learnMoreBtn) {
        learnMoreBtn.addEventListener('click', () => {
            const aboutSection = document.getElementById('about');
            if (aboutSection) {
                const offsetTop = aboutSection.offsetTop - 80;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    }
}

// 加载路线数据
async function loadRoutesData() {
    try {
        const response = await fetch('/data/routes.json?v=' + new Date().getTime());
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        routesData = data.routes;
        console.log('路线数据加载成功:', routesData.length, '条路线');
    } catch (error) {
        console.error('加载路线数据失败:', error);
        showError('路线数据加载失败');
    }
}

// 渲染路线卡片
let displayedRoutes = 0;
const routesToShowInitially = 2;

function renderRouteCards(loadAll = false) {
    const routesGrid = document.getElementById('routes-grid');
    const loadMoreContainer = document.getElementById('load-more-container');
    const loadMoreBtn = document.getElementById('load-more-btn');

    if (!routesGrid || !routesData) {
        console.error('路线数据或容器未找到');
        return;
    }

    if (!loadAll) {
        routesGrid.innerHTML = ''; // 重新渲染时清空
        displayedRoutes = 0;
    }

    const routesToRender = routesData;
    const startIndex = displayedRoutes;
    let endIndex = loadAll ? routesToRender.length : Math.min(startIndex + routesToShowInitially, routesToRender.length);

    if (!loadAll && displayedRoutes === 0) {
        endIndex = routesToShowInitially;
    }

    for (let i = startIndex; i < endIndex; i++) {
        if (i < routesToRender.length) {
            const route = routesToRender[i];
            const routeCard = createRouteCard(route);
            routesGrid.appendChild(routeCard);
            displayedRoutes++;
        }
    }

    if (routesToRender.length > routesToShowInitially && displayedRoutes < routesToRender.length) {
        loadMoreContainer.classList.remove('hidden');
        loadMoreBtn.removeEventListener('click', handleLoadMore); // 确保移除旧的监听器
        loadMoreBtn.addEventListener('click', handleLoadMore, { once: true });
    } else {
        loadMoreContainer.classList.add('hidden');
    }
}

function handleLoadMore() {
    const routesGrid = document.getElementById('routes-grid');
    const loadMoreContainer = document.getElementById('load-more-container');
    const routesToRender = routesData.slice(displayedRoutes);

    routesToRender.forEach(route => {
        const routeCard = createRouteCard(route);
        routesGrid.appendChild(routeCard);
    });

    displayedRoutes += routesToRender.length;
    loadMoreContainer.classList.add('hidden');
}

// 创建路线卡片
function createRouteCard(route) {
    const card = document.createElement('div');
    card.className = 'card card-route group cursor-pointer';
    
    const name = route.name[currentLanguage] || route.name.zh;
    const location = route.location[currentLanguage] || route.location.zh;
    const description = route.description[currentLanguage] || route.description.zh;
    const highlights = route.highlights[currentLanguage] || route.highlights.zh;
    const difficultyText = getTranslation(`routes.difficulty.${route.difficulty}`) || route.difficulty;
    
    card.innerHTML = `
        <div class="card-image">
            <img src="${route.images[0]}" alt="${name}" onerror="this.src='/assets/placeholder.jpg'">
            <div class="card-overlay"></div>
            <div class="card-badge">${difficultyText}</div>
        </div>
        <div class="card-content">
            <h3 class="card-title">${name}</h3>
            <p class="text-sm text-neutral-500 mb-2">${location}</p>
            <p class="card-description">${description.substring(0, 120)}...</p>
            <div class="card-meta">
                <div class="meta-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>${route.duration.days}${getTranslation('units.days') || '天'}</span>
                </div>
                <div class="meta-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <span>${route.distance}${getTranslation('units.km') || 'km'}</span>
                </div>
                <div class="meta-item">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11l5-5m0 0l5 5m-5-5v12"></path>
                    </svg>
                    <span>${route.elevation.highest}${getTranslation('units.m') || 'm'}</span>
                </div>
            </div>
            <div class="flex justify-between items-center mt-4">
                <span class="text-lg font-bold text-primary-600">¥${route.price.amount}</span>
                <button class="btn btn-primary btn-sm" onclick="viewRouteDetails('${route.id}')">
                    ${getTranslation('routes.viewDetails') || '查看详情'}
                </button>
            </div>
        </div>
    `;
    
    // 添加点击事件
    card.addEventListener('click', (e) => {
        if (!e.target.closest('button')) {
            viewRouteDetails(route.id);
        }
    });
    
    return card;
}

// 导入路线详情模块
import RouteDetails from './route-details.js';

// 查看路线详情 - 使用新的模块化函数
function viewRouteDetails(routeId) {
    RouteDetails.view(routeId, routesData, currentLanguage, getTranslation);
}

// 创建路线详情模态框
function createRouteModal(route) {
    // 移除现有模态框
    const existingModal = document.getElementById('route-modal');
    if (existingModal) {
        existingModal.remove();
    }
    
    const name = route.name[currentLanguage] || route.name.zh;
    const location = route.location[currentLanguage] || route.location.zh;
    const description = route.description[currentLanguage] || route.description.zh;
    const highlights = route.highlights[currentLanguage] || route.highlights.zh;
    const bestSeason = route.bestSeason[currentLanguage] || route.bestSeason.zh;
    const difficultyText = getTranslation(`routes.difficulty.${route.difficulty}`) || route.difficulty;
    
    const modal = document.createElement('div');
    modal.id = 'route-modal';
    modal.className = 'fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50';
    modal.innerHTML = `
        <div class="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div class="relative">
                <img src="${route.images[0]}" alt="${name}" class="w-full h-64 object-cover rounded-t-2xl" onerror="this.src='/assets/placeholder.jpg'">
                <button class="absolute top-4 right-4 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 transition-all" onclick="closeRouteModal()">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
            <div class="p-6">
                <div class="flex justify-between items-start mb-4">
                    <div>
                        <h2 class="text-3xl font-bold text-neutral-900 mb-2">${name}</h2>
                        <p class="text-lg text-neutral-600">${location}</p>
                    </div>
                    <div class="text-right">
                        <div class="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-sm font-semibold mb-2">
                            ${difficultyText}
                        </div>
                        <div class="text-2xl font-bold text-primary-600">¥${route.price.amount}</div>
                    </div>
                </div>
                
                <div class="grid md:grid-cols-4 gap-4 mb-6">
                    <div class="text-center p-4 bg-neutral-50 rounded-lg">
                        <div class="text-2xl font-bold text-neutral-900">${route.duration.days}</div>
                        <div class="text-sm text-neutral-600">${getTranslation('units.days') || '天'}</div>
                    </div>
                    <div class="text-center p-4 bg-neutral-50 rounded-lg">
                        <div class="text-2xl font-bold text-neutral-900">${route.distance}</div>
                        <div class="text-sm text-neutral-600">${getTranslation('units.km') || 'km'}</div>
                    </div>
                    <div class="text-center p-4 bg-neutral-50 rounded-lg">
                        <div class="text-2xl font-bold text-neutral-900">${route.elevation.highest}</div>
                        <div class="text-sm text-neutral-600">${getTranslation('routes.elevation') || '最高海拔'}</div>
                    </div>
                    <div class="text-center p-4 bg-neutral-50 rounded-lg">
                        <div class="text-sm font-semibold text-neutral-900">${bestSeason}</div>
                        <div class="text-sm text-neutral-600">${getTranslation('routes.bestSeason') || '最佳季节'}</div>
                    </div>
                </div>
                
                <div class="mb-6">
                    <h3 class="text-xl font-bold text-neutral-900 mb-3">路线介绍</h3>
                    <p class="text-neutral-700 leading-relaxed">${description}</p>
                </div>
                
                <div class="mb-6">
                    <h3 class="text-xl font-bold text-neutral-900 mb-3">路线亮点</h3>
                    <ul class="space-y-2">
                        ${highlights.map(highlight => `<li class="flex items-start space-x-2">
                            <svg class="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                            </svg>
                            <span class="text-neutral-700">${highlight}</span>
                        </li>`).join('')}
                    </ul>
                </div>
                
                <div class="mb-6">
                    <h3 class="text-xl font-bold text-neutral-900 mb-3">路线地图</h3>
                    ${route.coordinates.komoot ? 
                        `<div class="mb-4">
                            <div class="komoot-info">
                                <div class="flex items-center justify-between mb-2">
                                    <h4 class="font-semibold text-neutral-900">专业轨迹数据</h4>
                                    <span class="komoot-badge">Komoot提供</span>
                                </div>
                                <p class="text-sm text-neutral-600">查看详细的海拔、距离和路线信息</p>
                            </div>
                            <div class="komoot-embed">
                                <iframe src="${route.coordinates.komoot}" width="100%" height="500" frameborder="0" scrolling="no"></iframe>
                            </div>
                        </div>` : 
                        `<div id="route-map" class="map-container"></div>`
                    }
                </div>
                
                ${route.videos ? `
                <div class="mb-6">
                    <h3 class="text-xl font-bold text-neutral-900 mb-3">视频介绍</h3>
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        ${route.videos.youtube ? `
                        <div class="video-container">
                            <div class="bg-neutral-50 rounded-lg p-4 mb-3">
                                <div class="flex items-center justify-between mb-2">
                                    <h4 class="font-semibold text-neutral-900">${route.videos.youtube.title[currentLanguage] || route.videos.youtube.title.zh}</h4>
                                    <span class="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full font-medium">YouTube</span>
                                </div>
                            </div>
                            <div class="video-embed">
                                <iframe 
                                    width="100%" 
                                    height="315" 
                                    src="https://www.youtube.com/embed/${route.videos.youtube.id}?si=-SwE5bCrDFdTwO_h" 
                                    title="YouTube video player" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    referrerpolicy="strict-origin-when-cross-origin" 
                                    allowfullscreen>
                                </iframe>
                            </div>
                        </div>
                        ` : ''}
                        
                        ${route.videos.bilibili ? `
                        <div class="video-container">
                            <div class="bg-neutral-50 rounded-lg p-4 mb-3">
                                <div class="flex items-center justify-between mb-2">
                                    <h4 class="font-semibold text-neutral-900">${route.videos.bilibili.title[currentLanguage] || route.videos.bilibili.title.zh}</h4>
                                    <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full font-medium">哔哩哔哩</span>
                                </div>
                            </div>
                            <div class="video-embed">
                                <iframe 
                                    src="//player.bilibili.com/player.html?isOutside=true&aid=${route.videos.bilibili.aid}&bvid=${route.videos.bilibili.bvid}&cid=${route.videos.bilibili.cid}&p=1" 
                                    width="100%" 
                                    height="315" 
                                    scrolling="no" 
                                    border="0" 
                                    frameborder="no" 
                                    framespacing="0" 
                                    allowfullscreen="true">
                                </iframe>
                            </div>
                        </div>
                        ` : ''}
                    </div>
                </div>
                ` : ''}
                
                <!-- 用户评论系统 -->
                <div class="mb-6">
                    <div id="route-comments-${route.id}">
                        <!-- 评论将在这里动态加载 -->
                    </div>
                </div>
                
                <div class="flex flex-col sm:flex-row gap-4">
                    <button class="btn btn-primary btn-lg flex-1" onclick="bookRoute('${route.id}')">
                        ${getTranslation('routes.bookNow') || '立即预订'}
                    </button>
                    <button class="btn btn-secondary btn-lg" onclick="shareRoute('${route.id}')">
                        ${getTranslation('common.share') || '分享'}
                    </button>
                    <button class="btn btn-ghost btn-lg" onclick="openInApp('${route.id}')">
                        📱 在App中导航
                    </button>
                </div>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    
    // 初始化评论系统
    setTimeout(() => {
        if (window.commentSystem) {
            window.commentSystem.renderComments(route.id, `route-comments-${route.id}`);
        }
    }, 100);
    
    // 初始化地图
    setTimeout(() => {
        // 只在没有Komoot轨迹时才初始化Mapbox地图
        if (!route.coordinates.komoot) {
            initializeRouteMap(route);
        }
    }, 100);
    
    // 阻止背景滚动
    document.body.style.overflow = 'hidden';
}

// 关闭路线模态框
function closeRouteModal() {
    const modal = document.getElementById('route-modal');
    if (modal) {
        modal.remove();
        document.body.style.overflow = '';
    }
}

// 初始化路线地图
function initializeRouteMap(route) {
    const mapContainer = document.getElementById('route-map');
    if (!mapContainer || !route.coordinates) {
        return;
    }
    
    try {
        // 注意：这里需要实际的Mapbox访问令牌
        mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
        
        const map = new mapboxgl.Map({
            container: 'route-map',
            style: 'mapbox://styles/mapbox/outdoors-v12',
            center: route.coordinates.center,
            zoom: 10
        });
        
        // 地图加载完成后添加路线轨迹
        map.on('load', async () => {
            await loadRouteTrack(map, route);
        });
        
        // 添加起点标记
        new mapboxgl.Marker({ color: '#2d9f63' })
            .setLngLat(route.coordinates.start)
            .setPopup(new mapboxgl.Popup().setHTML(`<h3>起点</h3><p>${route.name[currentLanguage] || route.name.zh}</p>`))
            .addTo(map);
        
        // 添加终点标记
        new mapboxgl.Marker({ color: '#dc2626' })
            .setLngLat(route.coordinates.end)
            .setPopup(new mapboxgl.Popup().setHTML(`<h3>终点</h3><p>${route.name[currentLanguage] || route.name.zh}</p>`))
            .addTo(map);
        
        // 添加导航控件
        map.addControl(new mapboxgl.NavigationControl());
        
    } catch (error) {
        console.error('地图初始化失败:', error);
        mapContainer.innerHTML = '<div class="flex items-center justify-center h-full text-neutral-500">地图加载失败</div>';
    }
}

// 预订路线
function bookRoute(routeId) {
    // 这里可以集成实际的预订系统
    alert('预订功能正在开发中，请通过联系我们页面获取更多信息！');
}

// 分享路线
function shareRoute(routeId) {
    const route = routesData.find(r => r.id === routeId);
    if (!route) return;
    
    const name = route.name[currentLanguage] || route.name.zh;
    const shareData = {
        title: `${name} - 徒步中国`,
        text: `发现中国最美徒步路线：${name}`,
        url: `${window.location.origin}#${routeId}`
    };
    
    if (navigator.share) {
        navigator.share(shareData).catch(console.error);
    } else {
        // 后备方案：复制到剪贴板
        navigator.clipboard.writeText(shareData.url).then(() => {
            showSuccess('链接已复制到剪贴板！');
        }).catch(() => {
            showError('分享失败，请手动复制链接');
        });
    }
}

// 显示成功消息
function showSuccess(message) {
    showToast(message, 'success');
}

// 显示错误消息
function showError(message) {
    showToast(message, 'error');
}

// 显示提示消息
function showToast(message, type = 'info') {
    const toast = document.createElement('div');
    toast.className = `fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-lg text-white transition-all duration-300 transform translate-x-full ${
        type === 'success' ? 'bg-green-500' :
        type === 'error' ? 'bg-red-500' :
        'bg-blue-500'
    }`;
    toast.textContent = message;
    
    document.body.appendChild(toast);
    
    // 显示动画
    setTimeout(() => {
        toast.classList.remove('translate-x-full');
    }, 100);
    
    // 自动隐藏
    setTimeout(() => {
        toast.classList.add('translate-x-full');
        setTimeout(() => {
            toast.remove();
        }, 300);
    }, 3000);
}

// 初始化导航栏
function initializeNavbar() {
    // 设置当前页面的活动导航项
    const currentPath = window.location.pathname;
    const navLinks = document.querySelectorAll('.nav-link');
    
    navLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href === currentPath || (currentPath === '/' && href === '#home')) {
            link.classList.add('active');
        }
    });
}

// 加载路线轨迹
async function loadRouteTrack(map, route) {
    if (!route.coordinates.routes) {
        console.log('该路线没有轨迹文件');
        return;
    }
    
    try {
        // 加载GeoJSON轨迹文件
        const response = await fetch(`/data/${route.coordinates.routes}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const geojsonData = await response.json();
        
        // 添加轨迹数据源
        map.addSource('route-track', {
            'type': 'geojson',
            'data': geojsonData
        });
        
        // 添加轨迹线条图层
        map.addLayer({
            'id': 'route-track-line',
            'type': 'line',
            'source': 'route-track',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round'
            },
            'paint': {
                'line-color': '#dc2626', // 红色
                'line-width': 4,
                'line-opacity': 0.8
            }
        });
        
        // 添加轨迹点图层（可选，显示轨迹点）
        map.addLayer({
            'id': 'route-track-points',
            'type': 'circle',
            'source': 'route-track',
            'paint': {
                'circle-radius': 3,
                'circle-color': '#dc2626',
                'circle-opacity': 0.6
            }
        });
        
        // 调整地图视图以适应轨迹
        const bounds = new mapboxgl.LngLatBounds();
        
        // 遍历GeoJSON数据获取边界
        if (geojsonData.type === 'FeatureCollection') {
            geojsonData.features.forEach(feature => {
                if (feature.geometry.type === 'LineString') {
                    feature.geometry.coordinates.forEach(coord => {
                        bounds.extend(coord);
                    });
                } else if (feature.geometry.type === 'Point') {
                    bounds.extend(feature.geometry.coordinates);
                }
            });
        } else if (geojsonData.type === 'Feature') {
            if (geojsonData.geometry.type === 'LineString') {
                geojsonData.geometry.coordinates.forEach(coord => {
                    bounds.extend(coord);
                });
            } else if (geojsonData.geometry.type === 'Point') {
                bounds.extend(geojsonData.geometry.coordinates);
            }
        }
        
        // 如果有有效边界，调整地图视图
        if (!bounds.isEmpty()) {
            map.fitBounds(bounds, {
                padding: 50,
                maxZoom: 14
            });
        }
        
        console.log('路线轨迹加载成功:', route.coordinates.routes);
        
    } catch (error) {
        console.error('加载路线轨迹失败:', error);
        // 轨迹加载失败不影响地图的基本功能
    }
}

// 在App中打开导航
function openInApp(routeId) {
    const route = routesData.find(r => r.id === routeId);
    if (!route) {
        console.error('路线未找到:', routeId);
        return;
    }
    
    const name = route.name[currentLanguage] || route.name.zh;
    
    // 创建App导航对话框
    const modal = document.createElement('div');
    modal.id = 'app-navigation-modal';
    modal.className = 'fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50';
    modal.innerHTML = `
        <div class="bg-white rounded-2xl max-w-md w-full p-6">
            <div class="text-center">
                <div class="mx-auto w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
                    <svg class="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                    </svg>
                </div>
                <h3 class="text-xl font-bold text-neutral-900 mb-2">在HikeChina App中导航</h3>
                <p class="text-neutral-600 mb-4">使用HikeChina移动应用获得更好的导航体验</p>
                <div class="bg-neutral-50 rounded-lg p-4 mb-6">
                    <h4 class="font-semibold text-neutral-900 mb-2">${name}</h4>
                    <p class="text-sm text-neutral-600">包含完整的GPS轨迹、离线地图和实时导航功能</p>
                </div>
                <div class="space-y-3">
                    <button class="btn btn-primary w-full" onclick="downloadApp()">
                        📱 下载HikeChina App
                    </button>
                    <button class="btn btn-secondary w-full" onclick="copyTrackLink('${routeId}')">
                        🔗 复制轨迹链接
                    </button>
                    <button class="btn btn-ghost w-full" onclick="closeAppModal()">
                        取消
                    </button>
                </div>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
}

// 关闭App导航对话框
function closeAppModal() {
    const modal = document.getElementById('app-navigation-modal');
    if (modal) {
        modal.remove();
        document.body.style.overflow = '';
    }
}

// 下载App（演示功能）
function downloadApp() {
    showToast('HikeChina App正在开发中，敬请期待！', 'info');
    closeAppModal();
}

// 复制轨迹链接
function copyTrackLink(routeId) {
    const route = routesData.find(r => r.id === routeId);
    if (!route || !route.coordinates.routes) {
        showError('该路线暂无轨迹文件');
        return;
    }
    
    const trackUrl = `${window.location.origin}/data/${route.coordinates.routes}`;
    
    navigator.clipboard.writeText(trackUrl).then(() => {
        showSuccess('轨迹文件链接已复制到剪贴板！');
        closeAppModal();
    }).catch(() => {
        showError('复制失败，请手动复制链接');
    });
}

// 全局导出主要功能供HTML调用
window.viewRouteDetails = viewRouteDetails;